import React, { useState, useEffect } from "react";
import "./TemporaryClosedPopup.css";

const TemporaryClosedPopup = () => {
  const [show, setShow] = useState(false);
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  const content = {
    en: {
      eyebrow: "HIRO JAPANESE BUFFET",
      title: "Temporary Closure & Remodeling Update",

      paragraphs: [
        "After serving our community for 15 years, Hiro Japanese Buffet is currently temporarily closed due to a water leak that occurred during our remodeling project.",

        "During the remodeling process, our contractor opened part of the roof. Heavy rain followed, and a large amount of water entered through the roof and ceiling, causing serious damage inside the restaurant.",

        "For the safety of our guests and employees, we had no choice but to temporarily close the restaurant.",

        "This has been a very difficult time for our family, but we are actively working to address the damage and continue the remodeling process, with the hope of reopening as soon as possible.",

        "Thank you to every customer who has supported Hiro over the past 15 years. We are truly grateful for all of your support throughout this journey. ❤️ We sincerely hope that when we reopen, you will come back and continue supporting us.",
      ],

      highlight1: "This is not the end of Hiro.",
      highlight2: "We will be back. 🍣❤️",

      final:
        "Please continue following our accounts. We will keep you updated on the remodeling progress and share the latest news about our reopening.",

      button: "Continue to Website",
    },

    zh: {
      eyebrow: "HIRO JAPANESE BUFFET",
      title: "临时停业及装修进度通知",

      paragraphs: [
        "在为社区服务了 15 年之后，Hiro Japanese Buffet 目前因装修期间发生的漏水问题而暂时停业。",

        "在装修过程中，我们的承包商拆开了部分屋顶。随后遇到大雨，雨水从屋顶和天花板大量渗入，导致餐厅内部受到严重损坏。",

        "为了保障顾客和员工的安全，我们不得不暂时关闭餐厅。",

        "这段时间对我们一家人来说非常艰难，但我们正在积极处理损坏，并继续推进装修，希望能够尽快重新营业。",

        "感谢过去 15 年来一直支持 Hiro 的每一位顾客。真的非常感谢大家一路以来的支持。 ❤️ 我们也真心希望，在我们重新开业后，大家还愿意回来继续支持我们。",
      ],

      highlight1: "这不是 Hiro 的结束。",
      highlight2: "我们一定会回来。 🍣❤️",

      final:
        "请继续关注我们的账号，我们会及时发布装修进度和重新开业的最新消息。",

      button: "继续浏览网站",
    },

    es: {
      eyebrow: "HIRO JAPANESE BUFFET",
      title: "Aviso de Cierre Temporal y Remodelación",

      paragraphs: [
        "Después de servir a nuestra comunidad durante 15 años, Hiro Japanese Buffet se encuentra temporalmente cerrado debido a una filtración de agua que ocurrió durante nuestro proyecto de remodelación.",

        "Durante el proceso de remodelación, nuestro contratista abrió una parte del techo. Poco después, hubo fuertes lluvias y una gran cantidad de agua entró por el techo y el cielo raso, causando daños graves dentro del restaurante.",

        "Por la seguridad de nuestros clientes y empleados, no tuvimos otra opción que cerrar temporalmente el restaurante.",

        "Este ha sido un momento muy difícil para nuestra familia, pero estamos trabajando activamente para reparar los daños y continuar con la remodelación, con la esperanza de poder reabrir lo antes posible.",

        "Gracias a cada uno de nuestros clientes que ha apoyado a Hiro durante los últimos 15 años. Estamos verdaderamente agradecidos por todo su apoyo a lo largo de este camino. ❤️ Esperamos sinceramente que, cuando volvamos a abrir, regresen y continúen apoyándonos.",
      ],

      highlight1: "Este no es el final de Hiro.",
      highlight2: "Volveremos. 🍣❤️",

      final:
        "Por favor, continúen siguiendo nuestras cuentas. Compartiremos actualizaciones sobre el progreso de la remodelación y las últimas noticias sobre nuestra reapertura.",

      button: "Continuar al Sitio",
    },

    ko: {
      eyebrow: "HIRO JAPANESE BUFFET",
      title: "임시 휴업 및 리모델링 진행 안내",

      paragraphs: [
        "지역 사회와 함께한 15년 동안 보내주신 성원에 감사드리며, Hiro Japanese Buffet는 현재 리모델링 과정에서 발생한 누수 문제로 인해 임시 휴업 중입니다.",

        "리모델링 과정에서 시공업체가 지붕 일부를 개방한 뒤 큰비가 내렸고, 빗물이 지붕과 천장을 통해 대량으로 유입되어 식당 내부에 심각한 피해가 발생했습니다.",

        "고객과 직원의 안전을 위해 저희는 부득이하게 식당 영업을 임시 중단하게 되었습니다.",

        "이번 일은 저희 가족에게 매우 힘든 시간이지만, 현재 피해 복구를 적극적으로 진행하고 있으며 리모델링 공사도 계속 이어가고 있습니다. 가능한 한 빨리 다시 영업할 수 있도록 최선을 다하겠습니다.",

        "지난 15년 동안 Hiro를 아껴주시고 응원해 주신 모든 고객분들께 진심으로 감사드립니다. 지금까지 함께해 주신 모든 분들의 성원에 정말 깊이 감사드립니다. ❤️ 재오픈 후에도 다시 찾아주시고 계속해서 저희를 응원해 주시기를 진심으로 바랍니다.",
      ],

      highlight1: "이것이 Hiro의 끝은 아닙니다.",
      highlight2: "저희는 반드시 다시 돌아오겠습니다. 🍣❤️",

      final:
        "앞으로도 저희 계정을 계속 지켜봐 주세요. 리모델링 진행 상황과 재오픈 관련 최신 소식을 빠르게 알려드리겠습니다.",

      button: "웹사이트 계속 보기",
    },
  };

  const text = content[language];

  const getLanguageCode = () => {
    if (language === "zh") return "zh";
    if (language === "es") return "es";
    if (language === "ko") return "ko";
    return "en";
  };

  return (
    <div className="closure-popup-overlay">
      <div className="closure-popup-container" lang={getLanguageCode()}>
        <div className="closure-popup-card">
          <p className="closure-eyebrow">{text.eyebrow}</p>

          <div className="closure-language-switcher">
            <button
              className={language === "en" ? "active" : ""}
              onClick={() => setLanguage("en")}
            >
              English
            </button>

            <button
              className={language === "zh" ? "active" : ""}
              onClick={() => setLanguage("zh")}
            >
              中文
            </button>

            <button
              className={language === "es" ? "active" : ""}
              onClick={() => setLanguage("es")}
            >
              Español
            </button>

            <button
              className={language === "ko" ? "active" : ""}
              onClick={() => setLanguage("ko")}
            >
              한국어
            </button>
          </div>

          <h2>{text.title}</h2>

          <div className="closure-divider" />

          <div className="closure-popup-body">
            {text.paragraphs.map((paragraph, index) => (
              <p key={index} className="closure-main-text">
                {paragraph}
              </p>
            ))}

            <div className="closure-highlight">
              <strong>{text.highlight1}</strong>
              <br />
              <strong>{text.highlight2}</strong>
            </div>

            <p className="closure-update">{text.final}</p>
          </div>
        </div>

        <button className="closure-popup-button" onClick={() => setShow(false)}>
          {text.button}
        </button>
      </div>
    </div>
  );
};

export default TemporaryClosedPopup;
